import type { DeepPartial } from '@tryiris-ai/common.protojs';
import type { StudioDevice } from '@tryiris-ai/common.protojs/studio/v1/studio';
import { isEmpty, toString } from '@tryiris-ai/js-types';
import type { Update } from './types.js';
import { locateProxy } from '#~/agent/index.js';
import { StudioError } from '#~/error/index.js';

/**
 * Update an existing device.
 *
 * @param deviceId - The ID of the device to be updated.
 * @param updates - Changes to be made to the device.
 * @param token - The token.
 */
export const update: Update = async (deviceId, updates, token) => {
  try {
    console.trace('$tourx update device', deviceId);
    const proxy = locateProxy(deviceId);

    if (!proxy) {
      throw new Error('ET-320');
    }

    // Define mutation
    const mutation: DeepPartial<StudioDevice> = {};

    const name = toString(updates.name);

    if (name) {
      mutation.name = name;
    }

    // Are there any changes to be made?
    if (isEmpty(mutation)) {
      return;
    }

    await proxy.mutate(
      {
        control: {
          studio: {
            device: {
              [deviceId]: mutation
            }
          }
        }
      },
      {}
    );

    await proxy.save(token);
  } catch (cause) {
    throw new StudioError(`Unable to update device: ${deviceId}`, { cause });
  }
};
